import * as React from "react";
import { QrReader } from "react-qr-reader";
import { useNavigate } from "react-router-dom";
import { setCurrentStep, setsteps } from "../Stepper/stepperSlice";
import { useDispatch } from "react-redux";
import NavbarStepper from "../Stepper/NavBarStepper";
import { useParams } from "react-router-dom";
import {
  useGetUninstallJobCardQuery, useAddjobCardMutation, useUninstallSmartNodeMutation,
  useUninstallReplacementSmartNodeMutation, useAddChangeLogMutation,
} from "../../api/apiSlice";
import { useEffect } from "react";
import {
  showError,
} from "../../../Global/notifications/notificationsSlice";
import { skipToken } from "@reduxjs/toolkit/query/react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { useConnectionMonitor } from "../connectionsTest";
import ConnectionAlert from "../ConnectionAlert";
import { useStepperStateRestoration } from "../useStepperStateRestoration";

export default function QRScanUninstall() {
  // Stepper state restoration
  useStepperStateRestoration();

  // Connection monitoring
  const {
    showAlert,
    showWeakWarning,
    handleRetry,
    handleDismiss,
    handleWeakWarningDismiss,
    responseTime,
    avgResponseTime,
    connectionDetails
  } = useConnectionMonitor();

  const [
    addChangeLog,
    {
      isSuccess: addChangeLogSuccess,
      isError: isaddChangeLogError,
      error: addChangeLogError,
    },
  ] = useAddChangeLogMutation();
  
  const [
    uninstallSmartnode,
    {
      isSuccess: uninstallSmartnodeSuccess,
      isError: isuninstallSmartnodeError,
      error: uninstallSmartnodeError,
    },
  ] = useUninstallSmartNodeMutation();

  const [
    uninstallReplacementSmartnode,
    {
      isSuccess: uninstallReplacementSmartnodeSuccess,
      isError: isuninstallReplacementSmartnodeError,
      error: uninstallReplacementSmartnodeError,
    },
  ] = useUninstallReplacementSmartNodeMutation();

  const [qrCodeData, setQRCodeData] = React.useState(null);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  let { install_state } = useParams();
  useEffect(() => { dispatch(setCurrentStep(0)); }, []);


  const [
    addJobCard,
    {
      data: job_card_data,
      isSuccess: isAddJobCardSuccess,
      isError: isAddJobCardError,
      error: addJobCardError,
    },
  ] = useAddjobCardMutation();

 
  const {
    data: job_card,
    isSuccess: isGetJobCardSuccess,
    isError: isGetJobCardError,
    error: getSmartNodeError,
  } = useGetUninstallJobCardQuery(
    qrCodeData
      ? {
          serial_number: qrCodeData.serial_number,
          imsi_number: qrCodeData.imsi_number,
        }
      : skipToken
  );


  useEffect(() => {
    if (isGetJobCardError) {
      dispatch(showError(getSmartNodeError.data.error));
      setIsProcessing(false);
    }
  }, [isGetJobCardError, job_card]);


 

  useEffect(() => {
    if ( isGetJobCardSuccess && qrCodeData && !isProcessing) {
      const { serial_number, imsi_number } = qrCodeData;
      if(job_card.state=="COM" && install_state=="UN"){
        
          const body = {
            serial_number:serial_number,
            change:"Started uninstall from field",
          };
          addChangeLog({ body: body });
    
      }
      else if( job_card.state=="COM" && install_state=="RE"){
        const body = {
          serial_number:serial_number,
          change:"Uninstalled device from field to do a replacement",
        };
        addChangeLog({ body: body });
      }
      else{
        setIsProcessing(false);
        dispatch(showError("This device has not been installed"));
      }
    } 
  }, [isGetJobCardSuccess, qrCodeData]);

  useEffect(() => {
    if (addChangeLogSuccess && qrCodeData && !isProcessing) {
      const { serial_number, imsi_number } = qrCodeData;
    
      if(job_card.state=="COM"){
        const body = {
          address: job_card.address,
          geyser_name: job_card.geyser_name || "",
          property_type: job_card.property_type || "house",
          building_name: job_card.building_name || null,
          unit_number: job_card.unit_number || null,
          customer_consent: job_card.customer_consent,
          breaker_control: job_card.breaker_control,
          solar_geyser: job_card.solar_geyser,
          solar_pv: job_card.solar_pv,
          ripple_replacement: job_card.ripple_replacement,
          timer_installed: job_card.timer_installed,
          aborted: false,
          state: "BEFWA",
          install_state: install_state,
          archived_serial_number: serial_number,
          archived_job_card_number: job_card.id,
          archived_imsi_number: imsi_number,
        };
        setIsProcessing(true);
        addJobCard({body:body})
        
      }
      else{
        setIsProcessing(false);
        dispatch(showError("This device has not been installed"));
      }
    } 
  }, [addChangeLogSuccess, qrCodeData]);

  useEffect(() => {
    if (isAddJobCardSuccess) {
      const { serial_number } = qrCodeData;
      if (install_state === "UN") {
        uninstallSmartnode({ body: { serial_number } });
      } else {
        uninstallReplacementSmartnode({ body: { serial_number } });
      }
    }
  }, [isAddJobCardSuccess, job_card]);

  useEffect(() => {
    if (uninstallSmartnodeSuccess || uninstallReplacementSmartnodeSuccess) {
      const { serial_number, imsi_number } = qrCodeData;
      navigate(`/installer/${job_card_data.job_card_reference_id}/${serial_number}/${imsi_number}/work_area_before_install/`);
    }
  }, [uninstallSmartnodeSuccess, uninstallReplacementSmartnodeSuccess]);

  return (
    <>
      {/* Connection Alert */}
      {showAlert && (
        <ConnectionAlert
          onRetry={handleRetry}
          onClose={handleDismiss}
          connectionDetails={connectionDetails}
          position="top"
          alertType="error"
        />
      )}
      
      {/* Weak Connection Warning */}
      {showWeakWarning && (
        <ConnectionAlert
          onRetry={handleRetry}
          onClose={handleWeakWarningDismiss}
          connectionDetails={connectionDetails}
          position="top"
          alertType="warning"
          responseTime={responseTime || avgResponseTime}
        />
      )}
      
      <NavbarStepper />

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 100px)", backgroundColor: "#000", px: 2 }}>
        {/* Viewfinder */}
        <Box sx={{ position: "relative", width: "85vw", height: "85vw", mb: 3 }}>
          {/* Corner brackets */}
          <Box sx={{ position: "absolute", top: 0, left: 0, width: 32, height: 32, borderTop: "3px solid #FDB940", borderLeft: "3px solid #FDB940", borderTopLeftRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", top: 0, right: 0, width: 32, height: 32, borderTop: "3px solid #FDB940", borderRight: "3px solid #FDB940", borderTopRightRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: 0, left: 0, width: 32, height: 32, borderBottom: "3px solid #FDB940", borderLeft: "3px solid #FDB940", borderBottomLeftRadius: "4px", zIndex: 2, pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: 0, right: 0, width: 32, height: 32, borderBottom: "3px solid #FDB940", borderRight: "3px solid #FDB940", borderBottomRightRadius: "4px", zIndex: 2, pointerEvents: "none" }} />

          <Box sx={{ width: "100%", height: "100%", overflow: "hidden", "& section": { height: "100% !important", paddingTop: "0 !important" }, "& section > div": { paddingTop: "0 !important", height: "100% !important", position: "relative !important" }, "& video": { objectFit: "cover !important", position: "static !important", width: "100% !important", height: "100% !important" } }}>
            <QrReader
              constraints={{ facingMode: "environment" }}
              onResult={(result, error) => {
                if (result && !qrCodeData) {
                  const qr_code_data = extractDataFromUrl(result.text);
                  setQRCodeData(qr_code_data);
                }
              }}
            />
          </Box>
        </Box>

        <Typography sx={{ color: "rgba(255,255,255,0.8)", textAlign: "center", fontSize: "0.95rem" }}>
          Scan QR Code of the device being uninstalled.
        </Typography>
      </Box>
    </>
  );
}

function extractDataFromUrl(url) {
  const urlParts = url.split("/");
  if (urlParts.length < 7) {
    throw new Error(
      `Invalid URL format: Current Part length${urlParts.length}`
    );
  }
  return {
    serial_number: urlParts[5],
    imsi_number: urlParts[6],
  };
}
